import React, { useEffect, useState } from 'react'
import intl from 'react-intl-universal'
import { OrdersChangeDateModal } from './modal'
import { useOrdersContext } from '../../context'
import Session from 'utils/user-storage'
import { getValidationForNegotiationOrder } from './utils'
import IconOrderCalendar from 'components/icons/icn-oder-calendar.icon'
import ButtonIcon from 'components/button-icon'
import { isLoadCompositionFlowBrewerySide } from 'utils/validations-general-settings'
import { ListOfOrderStatusesAbleToChangeOnBrewerySide, ListOfOrderStatusesAbleToChangeOnSupplierSide } from 'models/pedidos/statusPedido'

export const OrdersChangeDate = () => {
  const { items, checkbox } = useOrdersContext()
  const [alterableItems, setAlterableItems] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [alterableOrderStatus] = useState(() =>
    isLoadCompositionFlowBrewerySide()
      ? ListOfOrderStatusesAbleToChangeOnBrewerySide
      : ListOfOrderStatusesAbleToChangeOnSupplierSide
  );

  useEffect(() => {
    const checkedItems = items.filter(item => checkbox.includes(item.Id))
    
    const alterableItems = checkedItems
      .filter(item => alterableOrderStatus.includes(item.OrderStatus) 
        && getValidationForNegotiationOrder(item, Session.get())
      )
    
    setAlterableItems(alterableItems)
  }, [checkbox])

  return (
    <React.Fragment>
      <div className='btn-content' title={intl.get('orders.changeOrder')}>
        <ButtonIcon
          buttonIcon={<IconOrderCalendar />}
          buttonType='default'
          buttonText={intl.get('commons.change')}
          onClick={() => setOpenModal(!openModal)}
          disabled={alterableItems.length === 0}
          style={{ width: '160px' }}
        />
      </div>
      <OrdersChangeDateModal
        open={openModal}
        close={() => setOpenModal(!openModal)}
        data={alterableItems}
      />
    </React.Fragment>
  )
}
